import React, { useState } from "react"
import { Offcanvas, CloseButton, Button, Form} from 'react-bootstrap'
import { FaFolderOpen } from 'react-icons/fa';
import IncidentzList, { CreateIncident } from "./IncidentzList";
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore'
import { spinner } from "../utils/Helper"
import { toast } from 'react-toastify'

import incidentIcon from '../images/stop.png';
import './xDocList.css';

export default function Incidentz(props) {
    const { theme = 'dark' } = props;
    const isDark = theme === 'dark';

    // HYBRID STATE: Fall back to local state if parent isn't managing visibility
    const [localShow, setLocalShow] = useState(false);
    const isCanvasOpen = props.isOpen !== undefined ? props.isOpen : localShow;

    const [xIncidents, setXIncidents] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const isPublicView = props.public === true;

    const handleToggleClose = () => {
        if (props.onToggle) props.onToggle();
        else setLocalShow(false);
    };

    const handleToggleOpen = () => {
        if (props.onToggle) props.onToggle();
        else setLocalShow(true);
    };

    // RESTORED: Fetching data strictly loads data and does not force side-effect toggling
    const getIncidents = () => {
        const db = getFirestore();
        spinner(true);
        const incidentRef = collection(db, "incidentz");
        let q;

        if (isPublicView && props.userEmail) {
            q = query(incidentRef, where("assignedEmail", "==", props.userEmail), where("isPrivate", "==", false));
        } else if (isPublicView) {
            q = query(incidentRef, where("isPrivate", "==", false));
        } else {
            q = query(incidentRef);
        }

        getDocs(q).then((snapshot) => {
            setXIncidents(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
            spinner(false);
        }).catch(err => {
            spinner(false);
            console.error(err);
            toast.error("Error loading APC Incident Archive.");
        });
    }

    const handleInitialClick = () => {
        getIncidents();
        handleToggleOpen();
    };

    const filteredIncidents = xIncidents.filter(item =>
        item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.assignedTo?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {isPublicView ? (
              
                    <Button onClick={handleInitialClick} className="">
                        <img src={incidentIcon} alt="Incident Reports" className="thumb hoverX animated fadeInRight" />
                        <br />
                        <span className="hoverX"> Incident</span>
                    </Button>
            ) : (
                
                    <Button variant={isDark ? "primary" : "outline-primary"} onClick={handleInitialClick} className="hoverX shadow-sm">
                        <span className="circle-btn centerCircle">⚠️</span>Incidents
                    </Button>
            )}

            <Offcanvas
                show={isCanvasOpen}
                onHide={handleToggleClose}
                placement="end"
                style={{ maxWidth: '550px', width: '100%' }}
                backdropClassName={isDark ? "adminBackdrop" : "docLight"}
                className={isDark ? "bg-dark text-white " : "xlight"}
            >
                <Offcanvas.Header className={isDark ? "border-bottom border-secondary border-opacity-20 bg-black bg-opacity-10" : "border-bottom bg-white bg-opacity-50"}>
                    <div className="w-100">
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-3 gap-2">
                            <div>
                                <h3 className={isDark ? "bg-dark text-white modified xTitle animated rollIn " : "modified animated rollIn xTitle text-dark m-0"} >Incidentz</h3>
                            </div>
                            <div className="d-flex align-items-center gap-2 ms-auto ms-sm-0">
                                {!isPublicView && <CreateIncident theme={theme} onSuccess={getIncidents} />}
                                <CloseButton variant={isDark ? "white" : undefined} onClick={handleToggleClose} />
                            </div>
                        </div>
                        <Form.Control
                            type="search"
                            placeholder="🔎 Search subject..."
                            className={isDark ? "glass-search" : "form-control shadow-sm"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="custom-scrollbar p-2 p-md-3">
                    {filteredIncidents.length > 0 ? (
                        filteredIncidents.map((x) => <IncidentzList key={x.id} {...x} theme={theme} public={isPublicView} onDeleteSuccess={getIncidents} />)
                    ) : (
                        <div className="text-center py-5 opacity-25">
                            <FaFolderOpen size={40} className="mb-3" />
                            <p className={`fw-bold ${isDark ? 'text-white' : 'text-dark'} opacity-50`}>No records matched your search.</p>
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}